export default __webpack_public_path__ + "static/media/before-after-emojis.7219c490.png";